import { WIZARD_STEPS } from '../../constants/defaults';
import './ProgressBar.css';

export default function ProgressBar({ currentStep, onStepClick }) {
  return (
    <div className="progress-bar">
      <div className="progress-bar__steps">
        {WIZARD_STEPS.map((step, index) => (
          <button
            key={step.id}
            type="button"
            className={`progress-bar__step ${
              index === currentStep ? 'progress-bar__step--active' : ''
            } ${index < currentStep ? 'progress-bar__step--completed' : ''}`}
            onClick={() => onStepClick?.(index)}
            aria-current={index === currentStep ? 'step' : undefined}
          >
            <span className="progress-bar__step-number">
              {index < currentStep ? (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3">
                  <polyline points="20 6 9 17 4 12" />
                </svg>
              ) : (
                index + 1
              )}
            </span>
            <span className="progress-bar__step-label">{step.title}</span>
          </button>
        ))}
      </div>
      <div className="progress-bar__track">
        <div 
          className="progress-bar__fill"
          style={{ width: `${(currentStep / (WIZARD_STEPS.length - 1)) * 100}%` }}
        />
      </div>
    </div>
  );
}
